<template>
  <div class="p-4 rounded ring-1 ring-gray-30 bg-gray-10">
    <coupon-title :is-active="false" :title="props.item.title!" />
    <coupon-divider :is-active="false" />
    <div class="flex items-center justify-between gap-1 text-sm">
      <coupon-deadline :is-active="false" :end-at="props.item.end_at!" />
      <span class="text-gray-60">{{ couponStatusTextMap[props.item.status!] }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import CouponTitle from '@/components/member/coupons/coupon-title.vue'
import CouponDivider from '@/components/member/coupons/coupon-divider.vue'
import CouponDeadline from '@/components/member/coupons/coupon-deadline.vue'

import { FpromoListStatus, type FpromoMemberPromoCode } from '@/types/api'

interface Props {
  item: FpromoMemberPromoCode
}

const props = defineProps<Props>()

const { t } = useI18n()

const couponStatusTextMap = computed<Record<number, string>>(() => ({
  [FpromoListStatus.ListStatusUsed]: t('promo.used'),
  [FpromoListStatus.ListStatusExpired]: t('promo.expired'),
  [FpromoListStatus.ListStatusNotApplicable]: t('promo.expired'),
  [FpromoListStatus.ListStatusFullyUsed]: t('promocode_all_claimed'),
}))
</script>
